import { render, staticRenderFns } from "./LensTagPopover.vue?vue&type=template&id=f5984e9e&scoped=true"
import script from "./LensTagPopover.vue?vue&type=script&lang=js"
export * from "./LensTagPopover.vue?vue&type=script&lang=js"
import style0 from "./LensTagPopover.vue?vue&type=style&index=0&id=f5984e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5984e9e",
  null
  
)

export default component.exports